import {
    setupAutocomplete,
    initAutocomplete,
    addAutoCompleteListener,
    fillInAddress,
    geolocate
} from "./gravity-forms-address-autocomplete.js";

export function oncarrotAddressAutocomplete(jQuery) {
    window.initAutocomplete = initAutocomplete;
    window.addAutoCompleteListener = addAutoCompleteListener;
    window.fillInAddress = fillInAddress;
    window.geolocate = geolocate;
    jQuery(document).ready(setupAutocomplete.bind(null, jQuery));
}



// WEBPACK FOOTER //
// /site/web/app/plugins/oncarrot-address-autocomplete/index.js